module.exports = __webpack_public_path__ + "static/media/group.701d6c8b.svg";